/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UseCaseWrite } from './UseCaseWrite';
import { UseCaseWriteFromJSON, UseCaseWriteFromJSONTyped, UseCaseWriteToJSON } from './UseCaseWrite';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface AssessmentAiModel
 */
export interface AssessmentAiModel {
  /**
   *
   * @type {number}
   * @memberof AssessmentAiModel
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof AssessmentAiModel
   */
  name: string;
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof AssessmentAiModel
   */
  taskType?: TaskTypeEnum;
  /**
   *
   * @type {UseCaseWrite}
   * @memberof AssessmentAiModel
   */
  readonly useCase: UseCaseWrite;
}

/**
 * Check if a given object implements the AssessmentAiModel interface.
 */
export function instanceOfAssessmentAiModel(value: object): value is AssessmentAiModel {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('useCase' in value) || value['useCase'] === undefined) return false;
  return true;
}

export function AssessmentAiModelFromJSON(json: any): AssessmentAiModel {
  return AssessmentAiModelFromJSONTyped(json, false);
}

export function AssessmentAiModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssessmentAiModel {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    taskType: json['task_type'] == null ? undefined : TaskTypeEnumFromJSON(json['task_type']),
    useCase: UseCaseWriteFromJSON(json['use_case']),
  };
}

export function AssessmentAiModelToJSON(value?: Omit<AssessmentAiModel, 'id' | 'useCase'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    task_type: TaskTypeEnumToJSON(value['taskType']),
  };
}
